import React from 'react';
import { IconProps } from '../../DefaultIcon';

export function LetterTypesIcon({ className }: IconProps) {
  return (
    <svg
      width="115"
      height="67"
      viewBox="0 0 115 67"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1147_1828)">
        <path
          d="M115 3.61182V49.2254C115 50.4834 113.985 51.5182 112.707 51.5182H48.1348L115 3.61182Z"
          fill="#EAEDF8"
        />
        <path
          d="M98.0754 51.4979L31.2305 3.4292V49.2051C31.2305 50.4631 32.2451 51.4979 33.5236 51.4979"
          fill="#D6DBE7"
        />
        <path
          d="M48.1345 51.4979L73.0542 33.5812L31.2305 3.61182V49.2254C31.2305 50.4834 32.2451 51.5182 33.5236 51.5182H48.1548L48.1345 51.4979Z"
          fill="#EAEDF8"
        />
        <path
          d="M71.6946 33.9667C72.1004 34.2913 72.6077 34.4942 73.1151 34.4942C73.6224 34.4942 74.1094 34.2913 74.5356 33.9667C84.6414 26.0127 115 5.39734 115 5.39734V3.59146C115 1.62326 113.376 0 111.388 0H34.66C32.7524 0 31.2305 1.5421 31.2305 3.42913V5.45821C31.2305 5.45821 61.5887 26.0127 71.6946 33.9667Z"
          fill="#00C4B3"
        />
        <path
          d="M69.5441 27.2505V65.113C69.5441 66.1681 68.6918 67.0203 67.6569 67.0203H14.043L69.5441 27.2708V27.2505Z"
          fill="#EAEDF8"
        />
        <path
          d="M55.5011 67L0 27.1084V65.1129C0 66.1681 0.852303 67.0203 1.88724 67.0203"
          fill="#D6DBE7"
        />
        <path
          d="M14.0427 67L34.7212 52.1269L0 27.2505V65.113C0 66.1681 0.852303 67.0203 1.88724 67.0203H14.0427V67Z"
          fill="#EAEDF8"
        />
        <path
          d="M33.6051 52.4516C33.9501 52.7154 34.3559 52.8777 34.7821 52.8777C35.2082 52.8777 35.6141 52.7154 35.9591 52.4516C44.34 45.8572 69.5439 28.7521 69.5439 28.7521V27.2506C69.5439 25.607 68.2045 24.2678 66.5608 24.2678H2.8613C1.27845 24.2475 0 25.5258 0 27.1085V28.7926C0 28.7926 25.2038 45.8572 33.6051 52.4516Z"
          fill="#00416B"
        />
      </g>
      <defs>
        <clipPath id="clip0_1147_1828">
          <rect width="115" height="67" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
